import { SET_BLACKOUT_PERIOD } from 'actions';
import { IBlackoutPeriod } from 'typings';

export function setBlackoutPeriod(blackoutPeriod?: IBlackoutPeriod) {
  return { blackoutPeriod, type: SET_BLACKOUT_PERIOD };
}
